import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { CustomDeleteButton } from './CustomDeleteButtons';

const LeaderboardFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="user_id" alwaysOn />
  </Filter>
);

export const LeaderboardList = (props) => (
  <List {...props} filters={<LeaderboardFilter />}>
    <Datagrid>
      <ReferenceField source="user_id" reference="users" label="Player">
        <TextField source="email" />
      </ReferenceField>
      <TextField source="competition_type" label="Competition Type" />
      <NumberField source="position" label="Position" />
      <NumberField source="score" label="Score" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);

export const LeaderboardShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <ReferenceField source="user_id" reference="users" label="Player">
        <TextField source="email" />
      </ReferenceField>
      <TextField source="competition_type" label="Competition Type" />
      <NumberField source="position" label="Position" />
      <NumberField source="score" label="Score" />
    </SimpleShowLayout>
  </Show>
);

export const LeaderboardCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="user_id" reference="users" label="Player">
        <SelectInput optionText="email" />
      </ReferenceInput>
      <SelectInput source="competition_type" label="Competition Type" choices={[
        { id: 'weekly', name: 'Weekly' },
        { id: 'monthly', name: 'Monthly' },
        { id: 'yearly', name: 'Yearly' },
      ]} />
      <NumberInput source="position" label="Position" />
      <NumberInput source="score" label="Score" />
    </SimpleForm>
  </Create>
);

export const LeaderboardEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput source="user_id" reference="users" label="Player">
        <SelectInput optionText="email" />
      </ReferenceInput>
      <SelectInput source="competition_type" label="Competition Type" choices={[
        { id: 'weekly', name: 'Weekly' },
        { id: 'monthly', name: 'Monthly' },
        { id: 'yearly', name: 'Yearly' },
      ]} />
      <NumberInput source="position" label="Position" />
      <NumberInput source="score" label="Score" />
    </SimpleForm>
  </Edit>
); 